import React from 'react';
import { useQueryAsState } from '../../model/history';
import { Icon } from '../Icon/Icon';

export function SortByIcon({
  sortBy,
  resetPageOnSort = true,
}: {
  sortBy: string;
  resetPageOnSort?: boolean;
}): JSX.Element {
  const [params, setParams] = useQueryAsState();

  const page = resetPageOnSort ? 0 : params.page;

  if (params.sortBy !== sortBy) {
    return (
      <Icon
        name="arrow-sortable"
        onClick={() => {
          setParams({
            sortBy,
            sortDir: 'desc',
            page,
          });
        }}
      />
    );
  }

  switch (params.sortDir) {
    case 'desc': {
      return (
        <Icon
          name="arrow-sortable-desc"
          onClick={() => {
            setParams({
              sortBy,
              sortDir: 'asc',
              page,
            });
          }}
        />
      );
    }
    case 'asc': {
      return (
        <Icon
          name="arrow-sortable-asc"
          onClick={() => {
            setParams({
              sortBy: '',
              sortDir: '',
              page,
            });
          }}
        />
      );
    }
    default: {
      return (
        <Icon
          name="arrow-sortable"
          onClick={() => {
            setParams({
              sortBy,
              sortDir: 'desc',
              page,
            });
          }}
        />
      );
    }
  }
}
